import React from 'react';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { usePageTitle } from '../hooks/usePageTitle';
import { contact } from '../data/site';
import { ContactForm } from '../components/contact/ContactForm';
export function Contact() {
  usePageTitle('Contact');
  return <section className="w-full bg-ink pt-16 md:pt-20" data-id="element-295" data-mp="1lqjhug9wgyss">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 py-16 md:px-10 lg:grid-cols-12 lg:py-24" data-id="element-296" data-mp="1lr1l3wuzcda7">
        <div className="lg:col-span-5" data-id="element-297" data-mp="xyl4lqqw4td0">
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.12em] text-amber" data-id="element-298" data-mp="t24e4pw7y2wr">
            <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-amber" data-id="element-299" data-mp="17rk4i4ru86bx" />
            Contact
          </p>
          <h1 className="mt-6 font-serif text-6xl leading-[0.95] tracking-tight text-paper md:text-7xl" data-id="element-300" data-mp="12z0fmbnp9ort">
            Zullen we iets <em className="text-amber" data-id="element-301" data-mp="f8d6jn21st3o">muzikaals</em> plannen?
          </h1>
          <p className="mt-8 max-w-sm text-lg leading-relaxed text-sand" data-id="element-302" data-mp="aabmaysvynqm">
            Vul het formulier in of neem direct contact op. Ik reageer meestal binnen één werkdag.
          </p>

          <ul className="mt-12 border-t border-line" data-id="element-303" data-mp="19fyzywvdv6r7">
            <li className="border-b border-line" data-id="element-304" data-mp="19enxd0doc51o">
              <a href={contact.phoneHref} className="group flex items-center gap-4 py-5" data-id="element-305" data-mp="1e8s7ttm5ev7i">
                <PhoneIcon aria-hidden className="h-5 w-5 text-amber" data-id="element-306" data-mp="1j5sb5wrm5jux" />
                <span data-id="element-307" data-mp="mgueg90azbv4">
                  <span className="block text-xs text-muted" data-id="element-308" data-mp="mhchpplduqcj">Bellen of appen</span>
                  <span className="font-serif text-2xl text-paper transition-colors duration-150 group-hover:text-amber" data-id="element-309" data-mp="qhmov5kwvmsz">{contact.phone}</span>
                </span>
              </a>
            </li>
            <li className="border-b border-line" data-id="element-310" data-mp="10gvfppkhclb4">
              <a href={`mailto:${contact.email}`} className="group flex items-center gap-4 py-5" data-id="element-311" data-mp="10hnch3ptcp2z">
                <MailIcon aria-hidden className="h-5 w-5 text-amber" data-id="element-312" data-mp="26w66bw5hvytq" />
                <span className="min-w-0" data-id="element-313" data-mp="2bug32b6vb7hg">
                  <span className="block text-xs text-muted" data-id="element-314" data-mp="2bxc07xaw5s4u">E-mail</span>
                  <span className="block truncate font-serif text-2xl text-paper transition-colors duration-150 group-hover:text-amber" data-id="element-315" data-mp="1m5sibrk3a2jm">{contact.email}</span>
                </span>
              </a>
            </li>
            <li className="flex items-center gap-4 border-b border-line py-5" data-id="element-316" data-mp="1w4rpt6t4bs51">
              <MapPinIcon aria-hidden className="h-5 w-5 text-amber" data-id="element-317" data-mp="1r6zpboeeqxp8" />
              <span data-id="element-318" data-mp="13g2op7s2bmta">
                <span className="block text-xs text-muted" data-id="element-319" data-mp="13hnkt1u0zdt9">Gevestigd in</span>
                <span className="font-serif text-2xl text-paper" data-id="element-320" data-mp="yikdtbuhixin">{contact.location} · {contact.region}</span>
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-sm bg-paper p-6 sm:p-10 lg:col-span-6 lg:col-start-7" data-id="element-321" data-mp="18fypky5gqy4m">
          <h2 className="sr-only" data-id="element-322" data-mp="18e451ky3t812">Contactformulier</h2>
          <ContactForm data-id="element-323" data-mp="kp34skzfd36v" />
        </div>
      </div>
    </section>;
}